import { useEffect, useRef } from "react";

const useOnCloseMessage = (onClose) => {
  // 用 useRef 記住你的 callback，避免因為 function 重新建立導致重複綁定
  const savedHandler = useRef(onClose);

  useEffect(() => {
    savedHandler.current = onClose;
  }, [onClose]);

  useEffect(() => {
    const handler = (event) => {
      if (event.data?.event === "close") {
        savedHandler.current?.();
      }
    };

    window.addEventListener("message", handler);

    return () => {
      window.removeEventListener("message", handler);
    };
  }, []);
};

export default useOnCloseMessage;
